import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import StyledSVG from './svgicon.styled';

function SvgIcon({
  icon,
  customClass,
  alt,
  active,
  themed,
  styling,
  backgroundShade
}) {
  const classNames = classnames({
    [customClass]: customClass !== undefined
  });

  return (
    <StyledSVG
      src={icon}
      alt={alt}
      active={active}
      themed={themed}
      className={classNames}
      type={styling}
      backgroundShade={backgroundShade}
    />
  );
}

SvgIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  alt: PropTypes.string,
  active: PropTypes.bool,
  themed: PropTypes.bool,
  styling: PropTypes.string,
  backgroundShade: PropTypes.string
};

SvgIcon.defaultProps = {
  customClass: undefined,
  active: false,
  themed: false,
  alt: '',
  styling: 'primary',
  backgroundShade: '95'
};

export default SvgIcon;
